import { supabase } from '../lib/supabase'
import { User } from '../types'

export interface NotificationConfigRow {
  key: string
  value: string
  label: string | null
  description: string | null
  updated_at: string
}

// Small in-memory cache so email-sending paths don't refetch on every send.
let cache: Record<string, string> | null = null

export const notificationsService = {
  async list(): Promise<NotificationConfigRow[]> {
    const { data, error } = await supabase
      .from('notification_config')
      .select('*')
      .order('key', { ascending: true })
    if (error) throw error
    return (data || []) as NotificationConfigRow[]
  },

  /** Get a single recipient value, with a fallback. Cached. */
  async getValue(key: string, fallback = ''): Promise<string> {
    if (cache && cache[key] !== undefined) return cache[key]
    try {
      const { data } = await supabase.from('notification_config').select('key, value')
      if (data) {
        const map = Object.fromEntries(data.map((r: any) => [r.key, r.value])) as Record<string, string>
        cache = map
        if (map[key] !== undefined) return map[key]
      }
    } catch {
      /* fall through to fallback */
    }
    return fallback
  },

  async setValue(key: string, value: string, actor: User | null): Promise<void> {
    const { error } = await supabase
      .from('notification_config')
      .update({ value, updated_by: actor?.id ?? null, updated_at: new Date().toISOString() })
      .eq('key', key)
    if (error) throw error
    if (cache) cache[key] = value
  },
}
